var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('purchase-sector', {
    attrs: {
      "title": "추천인 코드"
    }
  }, [_c('div', {
    staticClass: "purchase-code"
  }, [_c('v-sheet', {
    staticClass: "pa-6",
    attrs: {
      "color": "grey lighten-3"
    }
  }, [_c('v-text-field', {
    staticClass: "white",
    attrs: {
      "outlined": "",
      "hide-details": "",
      "placeholder": "추천인 코드를 입력하세요"
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.code,
      callback: function callback($$v) {
        _vm.code = $$v;
      },
      expression: "code"
    }
  })], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }